<template>
  <Modal :title="title" :showModal="showModal" class="edit-bot-form" @submit="submit">
    <template v-slot:body>
      <div class="row">
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Name*</label>
          <input class="form-control mt-2" type="text" :value="data.name" @change.stop.prevent="store.commit('name', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">User Name*</label>
          <input class="form-control mt-2" type="text" :value="meta.user_name" @change.stop.prevent="store.commit('meta.user_name', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-12">
          <label>Access Token*</label>
          <textarea class="form-control mt-2" placeholder="No Change" @change.stop.prevent="store.commit('meta.access_token', $event.target.value)"></textarea>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    /* prettier-ignore */
    return {
      modal: false,
      submitStructure: [
        'name',
        'meta'
      ]
    }
  },
  computed: {
    title() {
      return this.data.status == 'draft' ? 'Create Bot' : 'Edit Bot'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.data?._id
    },
    getUri() {
      return `bot/get/${this.accountId}`
    },
    submitUri() {
      return `bot/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    },
    meta() {
      return Object.assign({}, this.data?.meta || {})
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.showModal = true
        rawData.data.meta = Object.assign({}, rawData.data.meta)
        this.store.commit('', rawData.data)
      }
    },
    submit() {
      this.submitForm(this.data, {
        done: () => {
          this.$emit('close')
          this.$emitter.emit('TableList.Refresh')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
